var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAlertSmall = function SvgIconAlertSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16Z",
    fill: "#B37AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.52 10.873 17.627 8h-3.235l.11 2.873.459 7.628h2.098l.46-7.628ZM16.01 24c.57 0 1.043-.186 1.422-.558.379-.386.568-.861.568-1.427 0-.564-.19-1.033-.568-1.405-.38-.386-.853-.579-1.421-.579-.568 0-1.042.193-1.42.579-.394.372-.591.84-.591 1.405 0 .566.197 1.041.59 1.427.379.372.853.558 1.42.558Z",
    fill: "#fff"
  })));
};
export default SvgIconAlertSmall;